<template>
  <custom-dialog
    :openDialog="isOpen"
    :widthDialog="'800px'"
    :classDialog="'create-dialog custome-dialog'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <template #header>
      <h5 class="dialogTitle margin-left-10">
        Tìm kiếm nâng cao
      </h5>
    </template>

    <template #body>
      <el-form
        :model="advanceSearchForm"
        ref="form"
        label-position="left"
        label-width="140px"
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Số ký hiệu" class="formItem">
              <el-input
                v-model="advanceSearchForm.docCode"
                size="medium"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                placeholder="Số ký hiệu"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Trích yếu" class="formItem">
              <el-input
                v-model="advanceSearchForm.quote"
                size="medium"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                placeholder="Trích yếu"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Nội dung văn bản" class="formItem">
              <el-input
                v-model="advanceSearchForm.fileContent"
                size="medium"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                placeholder="Nội dung văn bản"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="Ngày văn bản" class="formItem">
              <el-date-picker
                v-model="advanceSearchForm.docDateRange"
                type="daterange"
                format="dd/MM/yyyy"
                class="style-fullWidth input-border__bottom input-border__radius__0 bg__transparent"
                :picker-options="dateQuickFilterOption1"
                range-separator="_"
                start-placeholder="_"
                end-placeholder="_"
                align="right"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Ngày chuyển" class="formItem labelWidth__auto">
              <el-date-picker
                v-model="advanceSearchForm.sendTimeRange"
                type="daterange"
                format="dd/MM/yyyy"
                class="style-fullWidth input-border__bottom input-border__radius__0 bg__transparent"
                :picker-options="dateQuickFilterOption"
                range-separator="_"
                start-placeholder="_"
                end-placeholder="_"
                align="right"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>

    <template #footer>
      <div class="flex-row form-button__action flex__left">
        <el-button
          size="medium"
          type="success"
          class="addDocs  color__white bg__blue btn-none__border"
          @click="search"
        >
          <i class="far fa-check-circle font-size__small"></i>
          &nbsp;Tìm kiếm
        </el-button>

        <el-button
          type="info"
          size="medium"
          class="btn__cancel btn-none__border"
          @click="reset"
        >Khởi tạo
        </el-button>
      </div>
    </template>
  </custom-dialog>
</template>

<script>
  import constants from "../../../constants";
  import utils from "../../../services/utils";
  import h from "../../../services/h";
  import dateUtils from "../../../dateUtils";
  import CustomDialog from "../../common/custom-dialog";

  export default {
    name: "vb-den-to-trinh-qua-han-advance-search-dialog",
    props: ["isOpen", "form"],
    components: {
      CustomDialog
    },

    data() {
      return {
        advanceSearchForm: {
          docDateRange: null,
          sendTimeRange: null,
          docCode: null,
          quote: null,
          fileContent: null
          // fromDocDate: null,
          // toDocDate: null,
          // fromSendTime: null,
          // toSendTime: null
        },
        dateQuickFilterOption: null,
        dateQuickFilterOption1: null,
      };
    },

    computed: {
      userDeptRole() {
        return this.$store.getters.userDeptRole;
      }
    },

    watch: {},

    created() {
      this.initDateQuickFilterOption();
      this.initForm();
    },

    methods: {
      initDateQuickFilterOption() {
        this.dateQuickFilterOption1 = utils.getDefaultDateQuickFilterOption();
        this.dateQuickFilterOption = {
          shortcuts: h.collect(
            [
              // constants.DATE_QUICK_FILTER.CODE.TO_TRINH_QUA_HAN_DEFAULT_RANGE,
              constants.DATE_QUICK_FILTER.CODE.HOM_NAY,
              constants.DATE_QUICK_FILTER.CODE.TUAN_NAY,
              constants.DATE_QUICK_FILTER.CODE.NAM_NAY,
              constants.DATE_QUICK_FILTER.CODE.LAST_WEEK,
              constants.DATE_QUICK_FILTER.CODE.LAST_30_DAYS,
              constants.DATE_QUICK_FILTER.CODE.LAST_YEAR
            ],
            item => utils.buildDateQuickFilterOption(item)
          )
        };
      },

      initForm() {
        this.advanceSearchForm.docCode = this.form.docCode;
        this.advanceSearchForm.quote = this.form.quote;
        this.advanceSearchForm.fileContent = this.form.fileContent;
        this.initDocDateRange(this.form.fromDocDate, this.form.toDocDate);
        this.initSendTimeRange(this.form.fromSendTime, this.form.toSendTime);
      },

      initDocDateRange(fromDocDate, toDocDate) {
        if (fromDocDate || toDocDate) {
          this.advanceSearchForm.docDateRange = [
            new Date(this.form.fromDocDate),
            new Date(this.form.toDocDate)
          ];
        } else {
          this.advanceSearchForm.docDateRange = null;
        }
      },

      initSendTimeRange() {
        if (this.form.fromSendTime || this.form.toSendTime) {
          this.advanceSearchForm.sendTimeRange = [
            new Date(this.form.fromSendTime),
            new Date(this.form.toSendTime)
          ];
        } else {
          this.advanceSearchForm.sendTimeRange = dateUtils.getDatesByQuickFilter(
            constants.DATE_QUICK_FILTER.CODE.TO_TRINH_QUA_HAN_DEFAULT_RANGE
          );
        }
      },

      convertToSubmitForm() {
        let fromDocDate = null;
        let toDocDate = null;
        if (this.advanceSearchForm.docDateRange) {
          fromDocDate = this.advanceSearchForm.docDateRange[0].getTime();
          toDocDate = this.advanceSearchForm.docDateRange[1].getTime();
        }
        let fromSendTime = null;
        let toSendTime = null;
        if (this.advanceSearchForm.sendTimeRange) {
          fromSendTime = this.advanceSearchForm.sendTimeRange[0].getTime();
          toSendTime = this.advanceSearchForm.sendTimeRange[1].getTime();
        }
        return {
          fromDocDate: fromDocDate,
          toDocDate: toDocDate,
          fromSendTime: fromSendTime,
          toSendTime: toSendTime,
          docCode: this.advanceSearchForm.docCode,
          quote: this.advanceSearchForm.quote,
          fileContent: this.advanceSearchForm.fileContent
        };
      },

      search() {
        this.$emit("doSearch", {advanceSearchForm: this.convertToSubmitForm()});
        this.$emit("closeDialog");
      },

      reset() {
        this.advanceSearchForm.docCode = null;
        this.advanceSearchForm.quote = null;
        this.advanceSearchForm.fileContent = null;
        this.initDocDateRange(null, null);
        this.initSendTimeRange(this.form.fromSendTime, this.form.toSendTime);
      }
    }
  };
</script>

<style scoped>
  .form {
    padding: 12px 20px 0 20px;
  }
</style>



// WEBPACK FOOTER //
// src/views/doc-in/to-trinh-qua-han/vb-den-to-trinh-qua-han-advance-search-dialog.vue